import _ from "lodash";
import { EmbedsFusionSearchStore } from "../stores/EmbedsFusionSearchStore";
import { parseConfig } from "./embeddable-helper";
import { EmbedsApiService } from "./embeds-api-service";
import { EmbedsFusionApiService } from "./embeds-fusion-api-service";
import { EmbeddableGlobalConfig } from "./interfaces";
import { QueryStore, QueryStoreConfig, setStoreApiService } from "ui-common";

export const configureStoreApiService = (config: EmbeddableGlobalConfig & { headers?: { [key: string]: string } }, setAsGlobalStoreService: boolean = true) => {
  const { apiUrl, embedToken, fusionApiUrl, fusionAppId } = config;
  const isFusion = !_.isEmpty(fusionApiUrl && fusionAppId);
  let apiService;

  if (isFusion) {
    apiService = new EmbedsFusionApiService({ apiUrl: fusionApiUrl, appId: fusionAppId });
  } else {
    apiService = new EmbedsApiService({
      embedToken,
      apiUrl,
      getRequestHeaders: () => config.headers,
    });
  }

  if (setAsGlobalStoreService) {
    setStoreApiService(apiService);
  }

  return apiService;
};

export const createQueryStore = (config: QueryStoreConfig, globalConfig: EmbeddableGlobalConfig, isPublicStore: boolean = false) => {
  const isSpringboard = globalConfig.apiType === 'springboard';
  const storeConfig = _.cloneDeep(config);
  const docFieldMap = globalConfig?.fusionDocFieldMap;

  if (config.queryParams?.analyticsData === false) { 
    _.set(storeConfig, 'queryParams.analyticsData', false); 
  }

  _.set(storeConfig, 'headers', { 'x-lw-client': isPublicStore ? 'embedStore' : 'embedComponent' });

  return isSpringboard ? new QueryStore(config) : new EmbedsFusionSearchStore({
    ...storeConfig,
    queryProfileId: globalConfig.fusionQueryProfileId || '',
    docFieldMap: parseConfig(docFieldMap),
    springboardApiService: configureStoreApiService(globalConfig, false),
  });
};
